module.exports = __webpack_public_path__ + "static/media/slim-preto.c3541219.jpg";